export default __webpack_public_path__ + "static/derrick2-b2c514b0c82932b84cd5571245d2e7fa.jpg";